<div id="cookie-banner-lgpd" class="cookie-banner-lgpd-visible cookie-banner-lgpd-animated" style="display:flex">
    <div class="cookie-banner-lgpd-container">
        <div class="cookie-banner-lgpd_text-box">
            <span class="cookie-banner-lgpd_text">
                Este portal usa cookies e outras tecnologias semelhantes para armazenar informações de localização e
                otimizar a navegação no portal.
                <a class="cookie-banner-lgpd-link cookie-banner-lgpd_privacy-portal-link" target="_blank"
                    style="color:#0069de" href="http://eddydata.com.br/empresa/protecao-de-dados">Saiba mais</a>
            </span>
        </div>
        <div class="cookie-banner-lgpd_button-box">
            <button (click)="aceitar()" class="cookie-banner-lgpd_accept-button"
                style="background-color:#0069de">PROSSEGUIR</button>
        </div>
    </div>
</div>